import { render, staticRenderFns } from "./ManageCustomPages.vue?vue&type=template&id=a2cfca60&scoped=true&"
import script from "./ManageCustomPages.vue?vue&type=script&lang=js&"
export * from "./ManageCustomPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cfca60",
  null
  
)

export default component.exports